<!-- src/components/MangoLoader.vue -->
<template>
  <div class="mango-loader">
    <div class="logo-wrapper">
      <img :src="logo" alt="Mangxo Logo" class="mango-img" />
      <div class="loader-text text-h5">Proyectos</div>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/logo_white_.png";

export default {
  name: "MangoLoader",

  data() {
    return {
      logo,
    };
  },
};
</script>

<style scoped>
.mango-loader {
  position: fixed;
  inset: 0;
  background: #1d1d1f;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.logo-wrapper {
  text-align: center;
}
.mango-img {
  width: 120px;
  animation: spin 3s linear infinite;
}
@keyframes spin {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.loader-text {
  margin-top: 12px;
  font-size: 1.2rem;
  font-weight: 600;
  color: #fff;
}
</style>
